import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import styles from './GlobalWarningBar.module.scss'

const GlobalWarningBar = ({ linkTo = null, title, description, icon }) => {
  useEffect(() => {
    document.documentElement.style.setProperty('--globalWarningBarHeight', '72px')

    return () => {
      document.documentElement.style.setProperty('--globalWarningBarHeight', '0px')
    }
  }, [])

  if (linkTo) {
    return (
      <>
        <div className={styles.spacer}></div>
        <Link to={linkTo}>
          <div className={styles.wrapper}>
            {icon}
            <div className={styles.texts}>
              <p className={styles.mainText}>{title}</p>
              <p className={styles.additionalText}>{description}</p>
            </div>
          </div>
        </Link>
      </>
    )
  }

  return (
    <>
      <div className={styles.spacer}></div>
      <div className={styles.wrapper}>
        {icon}
        <div className={styles.texts}>
          <p className={styles.mainText}>{title}</p>
          <p className={styles.additionalText}>{description}</p>
        </div>
      </div>
    </>
  )
}

export default GlobalWarningBar
